// Create Smart Group
export const CREATE_SMART_GROUP_REQUEST = 'CREATE_SMART_GROUP_REQUEST';
export const CREATE_SMART_GROUP_DONE = 'CREATE_SMART_GROUP_DONE';
export const CREATE_SMART_GROUP_FAILED = 'CREATE_SMART_GROUP_FAILED';
export const CREATE_SMART_GROUP_RESET = 'CREATE_SMART_GROUP_RESET';